import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { userService } from "../../../_services";
import AddEditTrainingModule from './AddEditModule';
import SortVideos from './SortVideos';
import SortModules from './SortModules';
import TrainingModule from './TrainingModule';
import PricingSheetModule from './PricingSheetModule';
import { Card, CardContent } from "../../ui/card";
import { Button } from "../../ui/button";
import { ArrowUpDown, Plus, Loader2 } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../ui/dialog";

class AdminTraining extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shortname: '',
            userId: '',
            userName: '',
            fullName: '',
            showModulePopup: false,
            showVideoPopup: false,
            moduleListPopup: false,
            trainingModuleData: [],
            moduleEditMode: false,
            moduleEditData: {},
            deleteVideoLoader: false,
            moduleLoader: true,
            delete_popup: false,
            moduleId: '',
            deleteModulesuccesmsg: '',
            orderModuleData: []
        }
    }

    componentDidMount() {
        let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        this.setState({ shortname: usernamedata.split(':')[0], fullName: usernamedata.split(':')[1] });
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] });
        
        // ONLY call training modules API (matching live - no GroupList here)
        this.getTrainingModules(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
    }

    // Use TrainingModule API (correct endpoint as per live)
    getTrainingModules(UserId, UserName) {
        this.setState({
            trainingModuleData: [],
            moduleLoader: true
        });
        try {
            // Use TrainingModule with correct parameters (UserId, UserName, Module)
            // For listing all modules, Module can be empty or 'all'
            userService.TrainingModule(UserId, UserName, '').then((apiData) => {
                console.log('TrainingModule API response:', apiData);
                if (apiData && apiData.length > 0 && apiData[0].modules) {
                    this.setState({ 
                        trainingModuleData: apiData[0].modules, 
                        orderModuleData: apiData[0].modules, 
                        moduleLoader: false 
                    });
                } else {
                    this.setState({ moduleLoader: false });
                }
            }).catch((err) => {
                console.error('Error fetching training modules:', err);
                this.setState({ moduleLoader: false });
            });
        } catch (err) {
            console.error('Error in getTrainingModules:', err);
            this.setState({ moduleLoader: false });
        }
    }

    deleteModule(moduleid) {
        this.setState({ deleteVideoLoader: true });
        try {
            userService.DeleteModule(moduleid).then((response) => {
                this.setState({ deleteVideoLoader: false });
                if (response.length > 0) {
                    if (response[0].code === '1') {
                        this.getTrainingModules(this.state.userId, this.state.userName);
                        this.setState({ deleteModulesuccesmsg: response[0].message });
                    }
                    setTimeout(() => {
                        this.setState({ deleteVideoLoader: false, delete_popup: false });
                    }, 1000);
                }
            });
        } catch (err) {
            console.error('Error deleting module:', err);
            this.setState({ deleteVideoLoader: false, delete_popup: false });
        }
    }

    showAddModulePopup() {
        this.setState({ showModulePopup: true });
    }

    hideAddModulePopup() {
        this.setState({ moduleEditMode: false, moduleEditData: {}, showModulePopup: false });
    }

    hideVideoPopup() {
        this.setState({ showVideoPopup: false });
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getTrainingModules(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
    }

    showDeleteModulePopup(moduleId) {
        this.setState({ deleteModulesuccesmsg: "", delete_popup: true, moduleId: moduleId });
    }

    hideDeleteModulePopup() {
        this.setState({ delete_popup: false });
    }

    editModule(isEditing, moduleData) {
        if (isEditing) {
            this.setState({ moduleEditMode: isEditing, moduleEditData: moduleData, showModulePopup: true });
        }
    }

    orderVideoList(moduleData) {
        this.setState({ moduleEditData: moduleData, showVideoPopup: true });
    }

    changeInModule() {
        this.getTrainingModules(this.state.userId, this.state.userName);
    }

    changeInVideo() {
        this.getTrainingModules(this.state.userId, this.state.userName);
    }

    showModuleList = () => {
        try {
            this.setState({ moduleListPopup: true });
        } catch (error) {
            console.error('Error showing module list:', error);
        }
    }

    hideModulePopup = () => {
        this.setState({ moduleListPopup: false });
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getTrainingModules(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
    }

    updateVideoList = (UserId, UserName) => {
        this.getTrainingModules(UserId, UserName);
    }

    render() {
        if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true) return <Navigate replace to="/signup" />
        localStorage.setItem('pagename', 'trainingpageadmin');
        
        return (window.atob(localStorage.getItem('UserRole')) === "Admin" ?
            <div className="w-full space-y-6">
                {/* Header outside card */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h1 className="text-2xl font-semibold text-brand-dark">Training</h1>
                        {this.state.moduleLoader && (
                            <Loader2 className="h-5 w-5 animate-spin text-brand-accent" />
                        )}
                    </div>
                    <div className="flex items-center gap-3">
                        {this.state.orderModuleData.length > 1 && this.state.trainingModuleData.length > 0 && (
                            <Button 
                                onClick={this.showModuleList}
                                variant="secondary"
                            >
                                <ArrowUpDown className="h-4 w-4 mr-2" />
                                Reorder Module
                            </Button>
                        )}
                        {this.state.trainingModuleData.length > 0 && (
                            <Button 
                                onClick={this.showAddModulePopup.bind(this)}
                                variant="secondary"
                            >
                                <Plus className="h-4 w-4 mr-2" />
                                Add Training Module
                            </Button>
                        )}
                    </div>
                </div>

                {/* Modules */}
                {!this.state.moduleLoader && this.state.trainingModuleData.length > 0 && (
                    <div className="space-y-6">
                        {this.state.trainingModuleData.map((item, index) => (
                            <TrainingModule 
                                key={index} 
                                moduleData={item} 
                                orderVideoList={this.orderVideoList.bind(this)} 
                                editModule={this.editModule.bind(this)} 
                                deleteModule={this.showDeleteModulePopup.bind(this)} 
                                changeInModule={this.changeInModule.bind(this)} 
                                changeInVideo={this.changeInVideo.bind(this)} 
                                videoDeleted={this.changeInVideo.bind(this)} 
                            />
                        ))}
                    </div>
                )}

                {/* Empty state */}
                {!this.state.moduleLoader && this.state.trainingModuleData.length === 0 && (
                    <Card className="border-gray-200 bg-white">
                        <CardContent className="flex flex-col items-center justify-center py-12">
                            <h3 className="text-xl font-semibold text-brand-dark mb-2">No modules added yet!</h3>
                            <p className="text-sm text-gray-600 mb-6">Please create a module for training</p>
                            <Button 
                                onClick={this.showAddModulePopup.bind(this)}
                                variant="secondary"
                            >
                                <Plus className="h-4 w-4 mr-2" />
                                Add Training Module
                            </Button>
                        </CardContent>
                    </Card>
                )}

                {/* Pricing Sheets */}
                <PricingSheetModule />

                {/* Modals */}
                {this.state.showModulePopup && (
                    <AddEditTrainingModule 
                        hideModal={this.hideAddModulePopup.bind(this)} 
                        mode={this.state.moduleEditMode ? "EDIT" : 'ADD'} 
                        moduleData={this.state.moduleEditData} 
                        changeInModule={this.changeInModule.bind(this)} 
                    />
                )}
                
                {this.state.showVideoPopup && (
                    <SortVideos 
                        renderVideos={this.updateVideoList} 
                        hideModal={this.hideVideoPopup.bind(this)} 
                        moduleData={this.state.moduleEditData} 
                    />
                )}
                
                {this.state.moduleListPopup && (
                    <SortModules 
                        renderVideos={this.updateVideoList} 
                        title={'Module list'} 
                        hideModal={this.hideModulePopup.bind(this)} 
                        moduleData={this.state.trainingModuleData} 
                    />
                )}
                
                {/* Delete Module Dialog */}
                <Dialog open={this.state.delete_popup} onOpenChange={this.hideDeleteModulePopup.bind(this)}>
                    <DialogContent>
                        <DialogHeader>
                            <DialogTitle>Delete Module</DialogTitle>
                            <DialogDescription>
                                Are you sure you want to delete this module?
                            </DialogDescription>
                        </DialogHeader>
                        {this.state.deleteModulesuccesmsg && (
                            <p className="text-sm text-green-600">{this.state.deleteModulesuccesmsg}</p>
                        )}
                        <DialogFooter>
                            <Button 
                                variant="outline" 
                                onClick={this.hideDeleteModulePopup.bind(this)}
                                disabled={this.state.deleteVideoLoader}
                            >
                                No
                            </Button>
                            <Button 
                                variant="destructive" 
                                onClick={() => this.deleteModule(this.state.moduleId)}
                                disabled={this.state.deleteVideoLoader}
                            >
                                {this.state.deleteVideoLoader ? 'Deleting...' : 'Yes'}
                            </Button>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
            </div> : <Navigate replace to="/page-not-found" />
        )
    }
}

export default AdminTraining;
